interface NothingFoundProps {
  contentType?: string;
  customClass?: string;
  customTitle?: string;
}

const NothingFound = ({
  contentType = '',
  customClass = '',
  customTitle,
}: NothingFoundProps): React.JSX.Element => {
  const NothingFoundMessage = customTitle || `There are no ${contentType} yet`;

  return (
    <div className={`text-3xl font-semibold ${customClass}`}>
      {NothingFoundMessage}
    </div>
  );
};

export default NothingFound;
